module.exports = __webpack_public_path__ + "img/aziende-alertmsg.8cd91fd1.png";